import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fancy-weaves',
  templateUrl: './fancy-weaves.component.html',
  styleUrls: ['./fancy-weaves.component.css']
})
export class FancyWeavesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
